import React from 'react';
import { useHistory } from 'react-router-dom';
import './Contact2.css'





const Cards = ({ title, imageSrc, description }) => {
  const history = useHistory();

  const handleClick = () => {
    // Map service titles to detail page names
    const serviceMap = {
      "Rénovation générale": "Rénovation clé en main",
      "Électricité": "Électricité",
      "Décoration": "Revêtement de sol",
      "Neuf": "Extension",
      "Salle de bain clé en main": "Salle de bain clé en main",
      "Placo / Isolation": "Placo",
      "Cuisine": "Rénovation clé en main",
      "Consultation personnalisée": "Rénovation clé en main",
      "Extension / Garage / Grange": "Extension",
      "Plomberie / Sanitaire": "Plomberie",
      "Carrelage / Faïence": "Revêtement de sol",
      "Peinture ": "Revêtement de sol"
    };
    
    const serviceName = serviceMap[title] || title;
    history.push(`/service/${encodeURIComponent(serviceName)}`);
  };

  return (
    <div className="bathroom-card" onClick={handleClick} style={{ cursor: 'pointer' }}>
      <div className="card-content">
        <h2 className="card-title">{title}</h2>
        <div className="card-image">
          <img
            src={imageSrc}
            alt={title}
          />
        </div>
        <p className="card-description">
          {description}
        </p>
      </div>
    </div>
  );
};

export default Cards;
